import { FC, PropsWithChildren, useEffect, useState } from 'react';
import JSB from '@bridge/sharee';
import cls from 'classnames';
import { useAtomValue } from 'jotai';
import { $UserAgent } from '@lemon8/web-app-shared/atom';
import { Lemon8Host } from 'shared/constants';
import SimpleToast from '~/components/simple-toast';
import TestSymbol from '~/components/test-symbol';

import './style.scss';

type ReportLayoutProps = PropsWithChildren & {
  className?: string;
};

export const ReportLayout: FC<ReportLayoutProps> = ({ children, className = '' }) => {
  const { isInApp, isMobile } = useAtomValue($UserAgent);
  const [isTestEnv, setIsTestEnv] = useState<boolean>(false);

  useEffect(() => {
    // 判断测试域名，给一个显著标志
    const urlHost = document.domain;
    if (
      urlHost.includes(Lemon8Host.TEST_ROW_SURFIX) ||
      urlHost.includes(Lemon8Host.TEST_VA_PREFIX) ||
      urlHost.includes(Lemon8Host.TEST_SG_PREFIX)
    ) {
      setIsTestEnv(true);
    }

    if (isInApp) {
      void JSB.view.preventScroll({
        isPrevent: true,
      });

      return () => {
        void JSB.view.preventScroll({
          isPrevent: false,
        });
      };
    }
  }, []);

  return (
    <div
      className={cls('app-wrapper', className, {
        isPC: !isMobile,
      })}
    >
      {isTestEnv && <TestSymbol />}
      {children}
      <SimpleToast />
    </div>
  );
};
